<template>
  <div class="zakat-donation-form-style-6">
    <!-- Amount Display -->
    <div class="zakat-amount-display">
      <div class="amount-container">
        <span class="currency-symbol">{{ getSymbol() }}</span>
        <span class="amount-value">{{ formatAmount(store.amount) }}</span>
      </div>
    </div>

    <!-- Currency Selection (if needed) -->
    <div class="currency-section" v-if="show_currency_dropdown && currencies && Object.keys(currencies).length > 1">
      <label class="field-label">Currency</label>
      <div class="el-custom-select">
        <el-select class="w-100" v-model="store.currency" @change="onCurrencyChange">
          <el-option 
            v-for="(curr, key) in currencies" 
            :value="key" 
            :key="key" 
            :label="curr"
          >
            {{ curr }}
          </el-option>
        </el-select>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();

const props = defineProps({
  currencies: {
    type: Object,
    default: () => ({})
  },
  symbols: {
    type: Object,
    default: () => ({})
  },
  symbol: {
    type: String,
    default: '$'
  },
  show_currency_dropdown: {
    type: Boolean,
    default: false
  }
});

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt) => {
  const { exchange_rates } = lifeline_donation || {};
  const syb = getSymbol();
  if(_.get && _.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt);
  }
  return amt;
};

const formatAmount = (amount) => {
  const convertedAmount = convert(amount);
  return parseFloat(convertedAmount).toFixed(2);
};

const onCurrencyChange = () => {
  console.log('Currency changed to:', store.currency);
};

onMounted(() => {
  // Check for Zakat amount from global variable or DOM
  const zakatWrapper = document.querySelector('.lifeline-zakat-donation');
  if (zakatWrapper) {
    const zakatAmount = parseFloat(zakatWrapper.getAttribute('data-zakat-amount')) || 0;
    if (zakatAmount > 0) {
      store.amount = zakatAmount;
      console.log('Zakat amount set in Style 6:', zakatAmount);
    }
  }
  
  // Also check global variable
  if (window.lifelineZakatAmount && parseFloat(window.lifelineZakatAmount) > 0) {
    store.amount = parseFloat(window.lifelineZakatAmount);
    console.log('Zakat amount from global variable:', store.amount);
  }
  
  // Ensure this is marked as a Zakat donation
  store.extras.donation_purpose = 'Zakat';
  store.recurring = false; // Disable recurring for Zakat
});
</script>

<style scoped>
.zakat-donation-form-style-6 {
  max-width: 450px;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}


.zakat-amount-display {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  padding: 32px 24px;
  border-radius: 16px;
  text-align: center;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(40, 167, 69, 0.3);
}

.amount-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.currency-symbol {
  font-size: 32px;
  font-weight: 600;
}

.amount-value {
  font-size: 48px;
  font-weight: 700;
  font-family: 'Georgia', serif;
}


.currency-section {
  margin-bottom: 24px;
}

.field-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}


.el-custom-select {
  width: 100%;
}


/* Responsive adjustments */
@media (max-width: 480px) {
  .amount-value {
    font-size: 36px;
  }
  
  .currency-symbol {
    font-size: 24px;
  }
  
  .zakat-amount-display {
    padding: 24px 20px;
  }
  
}
</style>